import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'menuList',
  pure: true
})
export class KebabMenuListPipe implements PipeTransform {
  transform(list: any[], item: any, status: string) {
    if (!status) {
      return [];
    }
    switch (status) {
      case 'PENDING':
        if (!item?.mainContact?.isActivated) {
          return list.filter((l) => ['ReInviteRepairer', 'Delete'].includes(l.action));
        }
        return list.filter((l) => ['AccessRepairerItem', 'ArchiveRepairerItem'].includes(l.action));
      case 'ACTIVE':
      case 'UNAVAILABLE':
        const activeExclusionList = ['ReInviteRepairer', 'Delete', 'RestoreRepairSite'];
        activeExclusionList.push(item.unpaidLicense ? 'FlagUnpaidLicense' : 'ClearUnpaidLicense');

        const quotingSystems = item?.quotingSystemsString?.split(',');
        if (quotingSystems?.length <= 1) {
          activeExclusionList.push('ChangeQuotingSystem');
        }

        return list.filter((l) => !activeExclusionList.includes(l.action));
      case 'ARCHIVED':
        return list.filter((l) => l.action === 'AccessRepairerItem');
      case 'SUSPENDED':
        const suspendedInclusionList = [
          'AccessRepairerItem',
          'RevokeAllTokens',
          'SetAutoArchiveDays',
          'ArchiveRepairerItem',
          'RequestScreenSharing',
          'RestoreRepairSite'
        ];
        if (item.unpaidLicense) {
          suspendedInclusionList.push('ClearUnpaidLicense');
        }
        return list.filter((l) => suspendedInclusionList.includes(l.action));
      default:
        return [];
    }
  }
}
